export default __webpack_public_path__ + "static/media/3.5e0c62fb.jpg";